import React, { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import {
  getDynamicSupportedCountries,
  SupportedCountryCode,
  getSavedBrowseCountry,
} from "./CountryPickerBanner";

interface CountrySelectorBadgeProps {
  countryCode?: SupportedCountryCode;
  onCountryChange?: (code: SupportedCountryCode) => void;
  onOpenModal?: () => void;
  className?: string;
}

export const CountrySelectorBadge: React.FC<CountrySelectorBadgeProps> = ({
  countryCode,
  onOpenModal,
  className = "",
}) => {
  const [currentCountry, setCurrentCountry] = useState<SupportedCountryCode>(
    () => countryCode || getSavedBrowseCountry() || "GH"
  );

  useEffect(() => {
    if (countryCode) {
      setCurrentCountry(countryCode);
    }
  }, [countryCode]);

  useEffect(() => {
    const handleCountryChange = (event?: any) => {
      const newCode = event?.detail || getSavedBrowseCountry() || "GH";
      setCurrentCountry(newCode);
    };

    window.addEventListener("storage", handleCountryChange);
    window.addEventListener("browseCountryChanged", handleCountryChange);

    return () => {
      window.removeEventListener("storage", handleCountryChange);
      window.removeEventListener("browseCountryChanged", handleCountryChange);
    };
  }, []);

  const countries = getDynamicSupportedCountries();
  const activeCountryObj =
    countries.find(c => c.code?.toUpperCase() === currentCountry?.toUpperCase()) ||
    countries.find(c => c.code?.toUpperCase() === getSavedBrowseCountry()?.toUpperCase()) ||
    countries[0] ||
    { code: "GH", name: "Ghana", flag: "🇬🇭" };

  return (
    <div className={`relative inline-block text-left ${className}`}>
      <button
        type="button"
        onClick={() => onOpenModal?.()}
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium bg-white/80 hover:bg-white text-gray-800 transition-all border border-gray-200/80 shadow-sm hover:shadow active:scale-95 cursor-pointer backdrop-blur-md"
      >
        <span className="text-sm leading-none">{activeCountryObj.flag}</span>
        <span className="font-semibold text-gray-900 tracking-tight">{activeCountryObj.name}</span>
        <ChevronDown className="w-3.5 h-3.5 text-gray-400 group-hover:text-gray-600 transition-transform" />
      </button>
    </div>
  );
};

export default CountrySelectorBadge;
